/* Badge: new partner-portal orders since I last looked (who sent how many; no money). */
import { useEffect, useState } from "react";
import axios from "axios";
import { Inbox } from "lucide-react";
import { API, getAuthHeader } from "@/App";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const get = () => axios.get(`${API}/order-register/partner-orders/new`, { headers: getAuthHeader() }).then(r => r.data);
const when = (iso) => new Date(iso).toLocaleString([], { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export const PartnerOrdersBadge = ({ onOpened, onFind }) => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  const [shown, setShown] = useState(null);
  useEffect(() => {
    const tick = () => { if (document.visibilityState === "visible") get().then(setD).catch(() => {}); };
    tick();
    const t = setInterval(tick, 60000);
    return () => clearInterval(t);
  }, []);
  const openIt = async () => {
    const fresh = await get().catch(() => d);
    setShown(fresh); setOpen(true);
    if (fresh?.count) {
      axios.post(`${API}/order-register/partner-orders/seen`, {}, { headers: getAuthHeader() }).catch(() => {});
      setD({ ...fresh, count: 0, partners: [] });
      onOpened?.();
    }
  };
  const n = d?.count || 0;
  return (
    <>
      <Button size="sm" variant="outline" className="relative h-8 text-xs" onClick={openIt} data-testid="partner-orders-badge-btn">
        <Inbox className="mr-1 h-3.5 w-3.5" /> Partner orders
        {n > 0 && <span className="absolute -right-2 -top-2 grid h-5 min-w-5 place-items-center rounded-full bg-rose-600 px-1 text-[10px] font-bold text-white" data-testid="partner-orders-badge-count">{n > 99 ? "99+" : n}</span>}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[85vh] max-w-xl overflow-y-auto" data-testid="partner-orders-dialog">
          <DialogHeader><DialogTitle>New partner orders</DialogTitle>
            <DialogDescription>{shown?.count ? `${shown.count} parcel(s) since ${when(shown.since)} — already in the Order Register. Tap a customer to find it.` : "Nothing new since you last looked."}</DialogDescription></DialogHeader>
          {(shown?.partners || []).map(p => (
            <details key={p.partner_name} open className="rounded-xl border p-2 text-sm" data-testid={`partner-orders-${p.partner_name}`}>
              <summary className="cursor-pointer"><b>{p.partner_name}</b> — {p.parcels} parcel(s), {p.lines} medicine line(s) <span className="text-xs text-slate-400">· last {when(p.last)}</span></summary>
              <div className="mt-1 divide-y text-xs">{p.items.map((it, i) => (
                <div key={i} className="flex gap-2 py-1"><button type="button" className="font-medium text-indigo-700 underline-offset-2 hover:underline" title="Show in Order Register"
                  onClick={() => { setOpen(false); onFind?.(it.customer_name); }} data-testid={`partner-orders-find-${i}`}>{it.customer_name}</button><span className="text-slate-500">{it.code} · {it.mode} · {it.lines} line(s)</span><span className="ml-auto text-slate-400">{when(it.created_at)}</span></div>))}
                {p.parcels > p.items.length && <div className="py-1 text-slate-400">+{p.parcels - p.items.length} more</div>}</div>
            </details>))}
        </DialogContent>
      </Dialog>
    </>
  );
};
